var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"swiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.images),function(image,index){return _c('swiper-slide',{key:index},[_c('img',{attrs:{"src":`${image}?cache=${new Date().getTime()}`}})])}),_c('div',{staticClass:"swiper-pagination swiper-pagination-alt",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }